define('BookingEngine/app-OceanCruises/main',['./settings', "util", '../app-General/dialog', '../app-BookNow/main', '../app-BEBasket/module', '../../app-Loader/main', '../../app-blazy/module', 'sumoselect'], function (settings, util, dialog, booknow, beBasket, loader, blazy) {
    return {
        run: function () {
            var summary = $(settings.container);

            if (summary.length === 0) {
                window.log('Master Cabin module will not be available.');
                return;
            }

            window.log('Loading cabin details');

            function discoverSortable() {
                $('.bookingTableFlex .cabinList .head>div').each(function () {

                    var columnHeader = $(this),
                        columnindex = columnHeader.index(),
                        table = columnHeader.parent().siblings('.body');

                    if (!isColumnSortable(table, columnindex)) {
                        columnHeader.find('.sortT').addClass("hidden");
                        columnHeader.data('sortable', false);
                    } else {
                        columnHeader.find('.sortT').removeClass("hidden");
                        columnHeader.data('sortable', true);
                    }
                });
            }

            function isNullUndefEmpty(variable) {
                return (variable === null || variable === undefined || variable === '');
            }

            function replaceUrlParam(url, paramName, paramValue) {
                var pattern = new RegExp('(\\?|\\&)(' + paramName + '=).*?(&|$)');
                var newUrl = url;

                if (url.search(pattern) >= 0) {
                    newUrl = url.replace(pattern, '$1$2' + paramValue + '$3');
                }
                else {
                    newUrl = newUrl + (newUrl.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
                }

                return newUrl;
            }

            // get one of the url parameters
            function getParameterByName(name) {
                var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);

                return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
            }

            // Show deckplan in lightbox
            $(document).on("click", ".deckPlan", function (event) {
                event.preventDefault();
                $('#deckplanModal').modal('show');
            });

            // Show Virtual Tour in lightbox
            $(document).on("click", ".virtualTour", function (event) {
                event.preventDefault();
                dialog.showDialog(settings.virtualtour);
            });

            function getColumnValues(table, columnindex) {
                var values = [];

                $(table).find('.departuresTable').each(function () {
                    var sortingValue = $(this).find(">div").eq(columnindex).find(".sortval").text();
                    if (!values.includes(sortingValue)) {
                        values.push(sortingValue);
                    }
                });

                return values;
            }

            function isColumnSortable(table, index) {
                var arr = getColumnValues(table, index),
                unique = arr.filter(function (element, index, thisArray) {
                    return index === thisArray.indexOf(element);
                });

                return unique.length > 1;
            }

            // pods table sort.
            $(document).on('click', '.head div', function () {
                var $this = $(this),
                sortable = $this.data('sortable');

                // only sort if we have something to sort
                if (sortable) {
                    var table = $this.parents('.bookingTableFlex').eq(0);
                            rows = table.find(".departuresTable").toArray().sort(sortColumnHeaders($this.index()));
                    //To reset the icon to double when a new column header is clicked.
                    $this.find('.sortT i').addClass('fa-sort').removeClass('fa-sort-up').removeClass('fa-sort-down');
                    this.desc = !this.desc;
                    $this.find('.sortT i').addClass('fa-sort-up').removeClass('fa-sort-down').removeClass('fa-sort');

                    if (this.desc) {
                        rows = rows.reverse();
                        $this.find('.sortT i').addClass('fa-sort-down').removeClass('fa-sort-up').removeClass('fa-sort');
                    }

                    for (var i = 0; i < rows.length; i++) {
                        table.append(rows[i]);
                    }
                }
            });

            function sortColumnHeaders(index) {
                return function (a, b) {
                    var sortA = sortAllValues(a, index), sortB = sortAllValues(b, index);
                    return $.isNumeric(sortA) && $.isNumeric(sortB) ? sortA - sortB : sortA.localeCompare(sortB);
                }
            }

            function sortAllValues(row, index) {
                return $(row).children('div').find('.sortval').eq(index).text();
            }

            // Search for cabin data with new No of Guests
            function Activate() {
                var packagecode = getParameterByName("packagecode"),
                    noOfGuests = getParameterByName("availability");

                //Availability can be naff data. Validate it before sending it to adobe and server.
                if (noOfGuests && noOfGuests.length > 1)
                    noOfGuests = noOfGuests.substring(0, 1);

                if (isNaN(parseInt(noOfGuests)) || (noOfGuests < 1 || noOfGuests > 2))
                    noOfGuests = 2;

                // Adobe 
                AdlAddUpdateItem("passengerNumber", noOfGuests);
                localStorage.setItem("passengerNumber", noOfGuests);

                loader.hide()
                loader.show("Searching for cabins...")

                // extend timeout on server searchcabins call
                $.ajax({
                    url: settings.activate,
                    type: 'POST',
                    data: JSON.stringify({ packagecode: packagecode, NoOfGuests: noOfGuests }),
                    dataType: 'html',
                    contentType: 'application/json; charset=utf-8',
                    timeout: 90000,
                    success: function (response) {
                        // poke new cabin data into grades module - need to remove whirly otherwise we end up with two!?
                        $('#oceanCruiseModule').replaceWith(response);

                        setGuaranteePanelStyling();
                        $('select').SumoSelect();

                        var cabinselected = $('#cruisePickYourCabin').data("chosen-cabin").length > 0,
                            gradeselected = $('#cruiseCabinGrades').data("chosen-grade").length > 0;

                        if (!(cabinselected || gradeselected)) {
                            // Show guarantee radio buttons
                            $('.summaryview').slideDown("slow", function () {
                                $('.summactiveviewaryview').slideUp("slow");
                            });

                            // Show cabin/guarantee selections
                            $('.chooseacabingradeActive').show();
                            $('.chooseacabingradeSummary').hide();
                            $('.chooseacabingradeDisabled').hide();
                            $('.pickyourcabinActive').hide();
                            $('.pickyourcabinSummary').hide();
                            $('.pickyourcabinDisabled').show();
                        } else {
                            // Show selected cabin
                            $('.chooseacabingradeActive').hide();
                            $('.chooseacabingradeSummary').show();
                            $('.chooseacabingradeDisabled').hide();
                            $('.pickyourcabinActive').hide();

                            // guarantee grade so don't show cabin module
                            cabinselected ? $('.pickyourcabinSummary').show() : $('.pickyourcabinSummary').hide();

                            $('.pickyourcabinDisabled').hide();

                            // adobe logging - eg Grade Outside
                            var chosenGrade = $('.chosencabintype').text().trim();
                            AdlAddUpdateItem("cabinGrade", chosenGrade);
                            localStorage.setItem("cabinGrade", chosenGrade);
                        }

                        // set the panel heights after panels are visible
                        cabinSelectionHeight();
                        discoverSortable();
                        loader.hide();
                    },
                    error: function (error) {
                        console.log("Error: " + response.errorDetails);
                        loader.hide();
                    }
                });
            }

            // hide the sort icons on any columns where the values are the same in every row
            $(document).ready(function () {
                AdlAddUpdateItem("pageName", "travel|purchase|checkout|cabingrade");

                function adlPageDeps() {
                    util.satelliteTrack("virtualPageViewTBJ");

                    //after the tracking call set previous page name to this value
                    //set a timeout to prevent it getting set before it's been read
                    //also add it to local storage so that a page change picks up the correct value
                    setTimeout(function () {
                        var prevpage = localStorage.getItem("previousPageName");

                        if (!isNullUndefEmpty(prevpage)) {
                            AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                        }

                        localStorage.setItem("previousPageName", "travel|purchase|checkout|cabingrade");
                    }, 999);
                };

                clearTimeout(VPVtimer);
                VPVtimer = setTimeout(adlPageDeps, 250);

                // boardBasis
                var cruiseboardbasis = $('#BoardBasis').text().trim();
                AdlAddUpdateItem("boardBasis", cruiseboardbasis);
                localStorage.setItem("boardBasis", cruiseboardbasis);

                // duration
                var duration = $('#numberOfNights').text().trim();
                AdlAddUpdateItem("numberOfNights", duration);
                localStorage.setItem("numberOfNights", duration);

                // no of departures
                AdlAddUpdateItem("numberOfDepartures", "1");

                // no of departure pods
                AdlAddUpdateItem("numberOfDepartureLists", "0");

                // selected departures pod
                AdlAddUpdateItem("departureAggregatedList", "No List");

                // selected view of lists of pods
                AdlAddUpdateItem("departureViewOption", "No List (Default)");

                // if we are on the review page, don't grab the cabin data
                if (window.location.href.toUpperCase().indexOf('REVIEW') === -1) {
                    Activate();

                    $('.head div').each(function () {
                        var columnindex = $(this).index(),
                                table = $(this).closest('.bookingTableFlex');

                        !isColumnSortable(table, columnindex) ? $(this).find('.sortT').addClass("hidden") : $(this).find('.sortT').removeClass("hidden");
                    });
                }
            });

            // open/close master cabin grade pods
            $(document).on("click", ".mastercabingradepod", function (e) {
                e.preventDefault();

                var $thispod = $(this),
                    $thispodinfo = $(this).next(".cabinmastergradePodInfo");

                $('.cabinmastergradePodInfo').not($thispodinfo).slideUp();

                $thispodinfo.finish().slideToggle("slow", function () {
                    $("html, body").animate({ scrollTop: $($thispod).offset().top }, 'slow', 'swing');
                });

                $('.mastercabingradepod').not(this).removeClass("active");
                $thispod.toggleClass("active");
            });

            // open/close pick your cabin pods
            $(document).on("click", ".deckpod", function (e) {
                e.preventDefault();

                var $thispod = $(this),
                        $thispodinfo = $thispod.next(".deckpodInfo");

                $('.deckpodInfo').not($thispodinfo).removeClass("active").slideUp();
                $('.deckpod').not(this).removeClass("active");

                $thispod.toggleClass("active");
                $thispodinfo.toggleClass("active");

                $thispodinfo.finish().slideToggle("slow", function () {
                    $("html, body").animate({ scrollTop: $($thispod).offset().top }, 'slow', 'swing');
                });
            });

            // Search for cabin data with new No of Guests
            $(document).on("click", ".oceanfilterView", function (e) {
                e.preventDefault();

                var noOfGuests = $('.guestsFilterOptions option:selected').val();
                window.location.href = replaceUrlParam(window.location.href, 'availability', noOfGuests);
                $('.oceanfilterView').addClass('disabled');
            });

            // Change No of Guests
            $(document).on("change", ".guestsFilterOptions", function (e) {
                e.preventDefault();
                $('.oceanfilterView').removeClass('disabled');
                 
            });

            // alternate between cabins & guarantees - show cabins
            $(document).on("click", ".cabinPicker input[type='radio']", function () {
                // hide the guarantees, show the cabins
                $('#guaranteeGrades').hide();
                $('#cabinMasterGrades').show();
                $('.pickyourcabinDisabled').show();

                // adobe logging
                AdlAddUpdateItem("cabinGuaranteeType", "Cabin Picker");
                localStorage.setItem("cabinGuaranteeType", "Cabin Picker");

                //ADL call
                AdlAddUpdateItem("pageName", "travel|purchase|checkout|cabingrade");

                function adlPageCabinGrade() {
                    util.satelliteTrack("virtualPageViewTBJ");

                    //after the tracking call set previous page name to this value
                    //set a timeout to prevent it getting set before it's been read
                    //also add it to local storage so that a page change picks up the correct value
                    setTimeout(function () {
                        var prevpage = localStorage.getItem("previousPageName");

                        if (!isNullUndefEmpty(prevpage)) {
                            AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                        }

                        localStorage.setItem("previousPageName", "travel|purchase|checkout|cabingrade");
                    }, 999);
                };

                clearTimeout(VPVtimer);
                VPVtimer = setTimeout(adlPageCabinGrade, 250);
            });

            // alternate between cabins & guarantees - show guarantees
            $(document).on("click", ".cabinGuarantee input[type='radio']", function () {
                // show the guarantees, hide the cabins
                $('#guaranteeGrades').show();
                $('#cabinMasterGrades').hide();
                $('.pickyourcabinDisabled').hide();

                // adobe logging
                AdlAddUpdateItem("cabinGuaranteeType", "Cabin Guarantee");
                localStorage.setItem("cabinGuaranteeType", "Cabin Guarantee");
                $('[data-adl-key="cabinGuaranteeType"]').text('Cabin Guarantee');

                //ADL call
                AdlAddUpdateItem("pageName", "travel|purchase|checkout|cabinguarantee");

                function adlPageGuarantee() {
                    util.satelliteTrack("virtualPageViewTBJ");

                    //after the tracking call set previous page name to this value
                    //set a timeout to prevent it getting set before it's been read
                    //also add it to local storage so that a page change picks up the correct value
                    setTimeout(function () {
                        var prevpage = localStorage.getItem("previousPageName");

                        if (!isNullUndefEmpty(prevpage)) {
                            AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                        }

                        localStorage.setItem("previousPageName", "travel|purchase|checkout|cabinguarantee");
                    }, 999);
                };

                clearTimeout(VPVtimer);
                VPVtimer = setTimeout(adlPageGuarantee, 250);
            });
           
            // choose a guarantee grade
            $(document).on("click", "#guaranteeGrades .grade-details a.btn", function () {
                function adlPageGuarantee() {
                    util.satelliteTrack("virtualPageViewTBJ");

                    //after the tracking call set previous page name to this value
                    //set a timeout to prevent it getting set before it's been read
                    //also add it to local storage so that a page change picks up the correct value
                    setTimeout(function () {
                        var prevpage = localStorage.getItem("previousPageName");

                        if (!isNullUndefEmpty(prevpage)) {
                            AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                        }

                        localStorage.setItem("previousPageName", "travel|purchase|checkout|cabinguarantee");
                    }, 999);
                };

                clearTimeout(VPVtimer);
                VPVtimer = setTimeout(adlPageGuarantee, 250);

                // Work out which grade was selected
                var chosenguaranteeGrade = $(this).data("guaranteegrade").trim(),
                    adaptedCabin = $(this).data("adapted"),
                    chosenguaranteePrice = $(this).data("price"),
                    chosenguaranteeNotes = $(this).data("notes"),
                    occupancy = $(this).data("occupancy"),
                    conditionsCheckbox = $("#conditions-" + chosenguaranteeGrade),
                    cabinDisplayName = $(this).data("display-name"),
                    shipCode = $('.shipCode').text();

                if (conditionsCheckbox.is(':checked')) {
                    $(".notification." + chosenguaranteeGrade).addClass('d-none');
                    $(this).toggleClass('btn-success').addClass('btn-primary').text("Select the guarantee");
                    $(this).toggleClass('btn-primary').addClass('btn-success').text("Selected guarantee");

                    loader.show("Reserving your cabin...");

                    $.post(settings.guaranteegradesurl, {
                        guaranteeGrade: chosenguaranteeGrade.toString().replace(/-/g, ' '),
                        guaranteePrice: chosenguaranteePrice,
                        shipCode: shipCode,
                        guaranteeCabinNotes: chosenguaranteeNotes,
                        adaptedCabin: adaptedCabin,
                        occupancy: occupancy
                    }, function (response) {
                        if (response.success) {
                            AdlAddUpdateItem("cabinGrade", chosenguaranteeGrade);

                            $('#cabinGrade').html(chosenguaranteeGrade);

                            AdlAddUpdateItem("occupancy", occupancy);
                            localStorage.setItem("occupancy", occupancy);

                            var chosenCabinTypeText = cabinDisplayName.length > 0 ? cabinDisplayName : "Cabin Guarantee";
                            $('.chosencabintype').text(chosenCabinTypeText);

                            $("html, body").animate({ scrollTop: $(".chooseacabingradeActive").offset().top }, 'slow', 'swing', function () {
                                $('.chooseacabingradeSummary').slideDown("slow", function () {
                                    $('.pickyourcabinActive').hide();
                                    $('.pickyourcabinSummary').hide();
                                    $('.pickyourcabinDisabled').hide();
                                    $('.chooseacabingradeActive').slideUp("slow");
                                });
                            });

                            booknow.ActivateBookNow();
                            beBasket.updateBasket();
                        }
                    });
                } else {
                    $(".notification." + chosenguaranteeGrade).removeClass('d-none');
                    loader.hide();
                }
            });

            // choose a master grade
            $(document).on("click", ".selectGrade", function (e) {
                e.preventDefault();

                AdlAddUpdateItem("BookingJourneyStep", "sagagrade");
                AdlAddUpdateItem("pageName", "travel|purchase|checkout|cabin");

                function adlPageCabinGrade() {
                    util.satelliteTrack("virtualPageViewTBJ");

                    //after the tracking call set previous page name to this value
                    //set a timeout to prevent it getting set before it's been read
                    //also add it to local storage so that a page change picks up the correct value
                    setTimeout(function () {
                        var prevpage = localStorage.getItem("previousPageName");

                        if (!isNullUndefEmpty(prevpage)) {
                            AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                        }

                        localStorage.setItem("previousPageName", "travel|purchase|checkout|cabin");
                    }, 999);
                };

                clearTimeout(VPVtimer);
                VPVtimer = setTimeout(adlPageCabinGrade, 250);

                $('.selectGrade').toggleClass('btn-success').addClass('btn-primary').text("Choose this cabin category");
                $(this).toggleClass('btn-primary').addClass('btn-success').text("Selected cabin category");

                // Work out which master grade was selected
                //simply keep the part which holds the master class
                var masterGradeClasses = $(this).attr("class").split(" "),
                        chosenGradeText = masterGradeClasses[0].split("-").join(" "),
                        chosenGrade = masterGradeClasses[0];

                $.post(settings.gradesurl, { masterGrade: chosenGrade }, function (response) {
                    if (response.success) {
                        $('.chosencabintype').text(chosenGradeText + ' cabin');

                        // adobe logging
                        AdlAddUpdateItem("cabinGrade", chosenGrade);
                        localStorage.setItem("cabinGrade", chosenGrade);

                            $('.chooseacabingradeSummary, .pickyourcabinActive').show();
                                $('.pickyourcabinDisabled, .chooseacabingradeActive').hide();

                                var currentGradeCode = $(this).find('.summarySubgradeImages:visible').attr('data-grade');
                                $(this).find("[data-grade-button='" + currentGradeCode + "']").addClass('checked');

                                //correct ship images;
                                var ship = $('.deckplan-select').attr('id');
                                $('#replaceImage').attr('src', '/content/content/ships/deckplans/' + ship + '/bg.png');
                                $('#backgroundImage').attr('src', '/content/content/ships/deckplans/' + ship + '/bg.png');
                        $("html, body").animate({ scrollTop: $(".pickyourcabinActive").offset().top - 15}, 'slow', 'swing');


                        var cabinsforselection = ".deckCabins." + chosenGrade;
                        $(cabinsforselection).show(function () {
                            discoverSortable();
                        });
                       
                        // Filter our filter options based on the chosen grade
                        createFilters(chosenGrade);

                        // no Of Cabins
                        var noOfCabins = 0;

                        $(cabinsforselection).each(function () {
                            var cabins = $(this).find('.numberCabins').text();
                            noOfCabins = noOfCabins + parseInt(cabins);
                        });

                        AdlAddUpdateItem("numberOfCabins", noOfCabins.toString());
                    }
                });
            });

            // change to a different cabin grade
            $(document).on("click", ".changecabingradebtn", function () {
                // make sure all the pods are closed
                $('.mastercabingradepod').each(function () {
                    $(this).next(".cabinmastergradePodInfo").css("display", "None");
                    $(this).removeClass("active");
                });

                var adlValue = $(".cabinPicker label").hasClass('checked') ? "travel|purchase|checkout|cabinguarantee" : "travel|purchase|checkout|cabingrade";
                AdlAddUpdateItem("pageName", adlValue);
                
                function adlPageChangeGrade() {
                    util.satelliteTrack("virtualPageViewTBJ");

                    //after the tracking call set previous page name to this value
                    //set a timeout to prevent it getting set before it's been read
                    //also add it to local storage so that a page change picks up the correct value
                    setTimeout(function () {
                        var prevpage = localStorage.getItem("previousPageName");
                        if (!isNullUndefEmpty(prevpage)) {
                            AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                        }

                        var lsValue = $(".cabinPicker label").hasClass('checked') ? "travel|purchase|checkout|cabinguarantee" : "travel|purchase|checkout|cabingrade";
                        localStorage.setItem("previousPageName", lsValue);

                    }, 999);
                };

                clearTimeout(VPVtimer);
                VPVtimer = setTimeout(adlPageChangeGrade, 250);

                // Hide the deck pods
                $('.deckCabins').hide();

                // hide the chosen grade images
                $('.summarySubgradeImages').css("display", "none");
                $('.summarySubGradeType').css("display", "none");

                // Untick the guarantee grade checkboxes
                $('.guaranteeconfirmed label').removeClass('checked');
                $('.guaranteeconfirmed label input').prop('checked', false);

                // show the master grades
                $("html, body").animate({ scrollTop: $(".chooseacabingradeSummary").offset().top }, 'slow', 'swing', function () {
                    $('.chooseacabingradeActive').slideDown("slow", function () {
                        var maxHeight = 0;

                        $('.cabinGuaranteePanel label').each(function () {
                            $(this).css('height', 'auto');
                            maxHeight = Math.max($(this).outerHeight(), maxHeight);
                        });

                        $('.cabinGuaranteePanel label').css({ 'height': maxHeight });
                        $('.chooseacabingradeSummary').slideUp("slow");
                        $('.chooseacabingradeDisabled').hide();

                        // if no selected cabin, show pick your cabin in disabled mode
                        if (!$('.cabinsummarytext .cabinprice').text()) {
                            $('.pickyourcabinActive').hide();
                            $('.pickyourcabinSummary').hide();

                            if ($(".cabinPicker label").hasClass('checked')) {
                                $('.pickyourcabinDisabled').show();
                            }
                        } else {
                            $('.pickyourcabinActive').hide();
                            $('.pickyourcabinSummary').show();
                        }
                    });
                });
            });

            // choose a cabin
            $(document).on("click", ".cabinbtn", function () {

                var $this = $(this);

                AdlAddUpdateItem("BookingJourneyStep", "sagacabin");
                AdlAddUpdateItem("pageName", "travel|purchase|checkout|cabingrade");

                function adlPageCabin() {
                    util.satelliteTrack("virtualPageViewTBJ");

                    //after the tracking call set previous page name to this value
                    //set a timeout to prevent it getting set before it's been read
                    //also add it to local storage so that a page change picks up the correct value
                    setTimeout(function () {
                        var prevpage = localStorage.getItem("previousPageName");

                        if (!isNullUndefEmpty(prevpage)) {
                            AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                        }

                        localStorage.setItem("previousPageName", "travel|purchase|checkout|cabin");
                    }, 999);
                };

                clearTimeout(VPVtimer);
                VPVtimer = setTimeout(adlPageCabin, 250);

                // Work out which cabin was selected
                $('.cabinbtn a').removeClass('btn-success').text("Choose cabin");
                $this.find('a').addClass('btn-success').text("Selected cabin");

                var cabinDetails = $this.closest('.bookingTableFlexRow').find('.cabindetail');
                var selectedCabin = {
                    "Cabin": {
                        CabinGrade: cabinDetails.data('cabin-grade'),
                        FullCabinSubgrade: cabinDetails.data('fullcabinsubgrade'),
                        CabinUrl: cabinDetails.find('img').attr('src'),
                        CabinNo: cabinDetails.data('cabin-number'),
                        CabinSubGrade: cabinDetails.data('sub-grade'),
                        CabinPrice: parseFloat(cabinDetails.data('cabin-price').replace(/[^0-9\.]+/g, "")),
                        CabinBedType: cabinDetails.data('bed-type'),
                        CabinBathType: cabinDetails.data('bath-type'),
                        CabinNotes: cabinDetails.find('.cabinnotes').text(),
                        RoomType: cabinDetails.data('sub-grade'),
                        AdaptedCabin: cabinDetails.data("adapted")
                    },
                    "DeckNumber": $('.deckpod.active .cabindeck').text(),
                    "DisplayPrice": cabinDetails.data('cabin-price'),
                    "ShipCode": $(".shipCode").text()
                };

                loader.show("Reserving your cabin...");

                // adobe
                AdlAddUpdateItem("cabinSubgrade", selectedCabin.Cabin.CabinSubGrade);
                localStorage.setItem("cabinSubgrade", selectedCabin.Cabin.CabinSubGrade);

                $.ajax({
                    url: settings.cabinsurl,
                    type: 'POST',
                    data: JSON.stringify(selectedCabin),
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    success: function (response) {
                        if (response.success) {
                            AdlAddUpdateItem("occupancy", selectedCabin.Cabin.CabinBedType);
                            localStorage.setItem("occupancy", selectedCabin.Cabin.CabinBedType);

                            var chosenCabinInfo = $('.chosencabininfo');
                            // Insert into chosen cabin div
                            chosenCabinInfo.find('.cabintitle h3').text('Cabin ' + selectedCabin.Cabin.CabinNo);
                            chosenCabinInfo.find('.cabinimageurl').attr('src', selectedCabin.Cabin.CabinUrl);
                            chosenCabinInfo.find('.cabingrade').text(selectedCabin.Cabin.CabinGrade);
                            chosenCabinInfo.find('.cabindeck').text(selectedCabin.DeckNumber);
                            chosenCabinInfo.find('.cabinsubgrade').text(selectedCabin.Cabin.CabinNo + " (Grade " + selectedCabin.Cabin.CabinSubGrade + ")");
                            chosenCabinInfo.find('.cabinbed').text(selectedCabin.Cabin.CabinBedType);
                            chosenCabinInfo.find('.cabinprice').text(selectedCabin.DisplayPrice);
                            chosenCabinInfo.find('.cabinnotes').text(selectedCabin.Cabin.CabinNotes);
                            chosenCabinInfo.find('.cabinbath').text(selectedCabin.Cabin.CabinBathType);
                            chosenCabinInfo.find('.bath').css("display", selectedCabin.Cabin.CabinBathType.trim().length > 0 ? "block" : "none");

                            // show/hide appropriately
                            $('.chooseacabingradeActive, .chooseacabingradeDisabled, .pickyourcabinDisabled, .pickyourcabinActive').hide();
                            $('.pickyourcabinSummary, .chooseacabingradeSummary').show();
                            $("html, body").animate({ scrollTop: $(".pickyourcabinSummary").offset().top - 15}, "slow", "swing");                                       


                            booknow.ActivateBookNow();
                            beBasket.updateBasket();
                        } else {
                            console.log("Error: " + response.errorDetails);
                            loader.hide();
                        }
                    },
                    error: function (error) {
                        console.log("Error: " + error.errorDetails);
                        loader.hide();
                    }
                });
            });

            $(document).on("click", ".changecabinbtn", function () {
                $('.deckpod').each(function () {
                    $(this).next(".deckpodInfo").css("display", "None");
                    $(this).removeClass("active");
                });

                AdlAddUpdateItem("pageName", "travel|purchase|checkout|cabin");

                function adlPageChangeCabin() {
                    util.satelliteTrack("virtualPageViewTBJ");

                    //after the tracking call set previous page name to this value
                    //set a timeout to prevent it getting set before it's been read
                    //also add it to local storage so that a page change picks up the correct value
                    setTimeout(function () {
                        var prevpage = localStorage.getItem("previousPageName");

                        if (!isNullUndefEmpty(prevpage)) {
                            AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                        }

                        localStorage.setItem("previousPageName", "travel|purchase|checkout|cabin");
                    }, 999);
                };

                clearTimeout(VPVtimer);
                VPVtimer = setTimeout(adlPageChangeCabin, 250);

                // show the master grades
                $("html, body").animate({ scrollTop: $(".pickyourcabinSummary").offset().top - 15}, 'fast', 'swing', function () {
                    $('.pickyourcabinSummary, .chooseacabingradeActive, .chooseacabingradeDisabled, .pickyourcabinDisabled').hide();
                    $('.pickyourcabinActive, .chooseacabingradeSummary').show();
                    
                });

            });

           
            $(document).on('click', ".guaranteeconfirmed input[type='checkbox']", function () {
               var $this = $(this);
                if ($this.is(":checked")) {
                    $this.parent("label").addClass("checked");
                } else {
                    $this.parent("label").removeClass("checked");
                }
              
            });
      


            // Create equal height of Cabin Radio Selection
            cabinSelectionHeight = function () {
                $('.cabinGuaranteePanel label');

                var maxHeight = 0;

                $('.cabinGuaranteePanel label').each(function () {
                    $(this).css('height', 'auto');
                    maxHeight = Math.max($(this).outerHeight(), maxHeight);
                });

                $('.cabinGuaranteePanel label').css({ 'height': maxHeight });
            }

            if ($(window).width() > 768) {
                cabinSelectionHeight();
            }

            $(window).on("resize", function () {
                if ($(window).width() > 768) {
                    cabinSelectionHeight();
                } else {
                    $('.cabinGuaranteePanel label').css({ 'height': 'auto' });
                }
            });

            setGuaranteePanelStyling = function () {
                $('.cabinGuaranteePanel input[type="radio"]').each(function () {
                    if ($(this).is(":checked")) {
                        $(this).parent('label').addClass("checked");
                    };
                });

                $('.cabinGuaranteePanel input[type="radio"]').change(function () {
                    $('.cabinGuaranteePanel label').removeClass("checked");

                    if ($(this).is(":checked")) {
                        $(this).parent('label').addClass("checked");
                    }
                });
                
               
            }

            setGuaranteePanelStyling();

            $('body').on('change', '.checkboxStyled input', function () {
                $(this).is(":checked") ? $(this).closest('label').addClass("checked") : $(this).closest('label').removeClass("checked");
            });

            createFilters = function (chosenGrade) {
                var cabinsforselection = ".deckCabins." + chosenGrade;
                var table = $(cabinsforselection).find('.cabinList');

                var bedcolumn = 2;
                var bathcolumn = 3;
                var bedtypes = [];
                var bathtypes = [];
               
               
                $(table).find('.body > .bookingTableFlexRow').each(
                    function() {
                        bedtypes.push($(this).find('div').eq(bedcolumn).find('.sortval').text());
                        bathtypes.push($(this).find('div').eq(bathcolumn).find('.sortval').text());

                    });
                var decktypes = $(cabinsforselection).find('.cabindeck').map(function () {
                    return $(this).text();
                }).get();
                bedtypes = bedtypes.filter(function(b) { return b; }); //removes empty values
                bathtypes = bathtypes.filter(function (b) { return b; });
                // set a bool to say if all the values in the column are the same
                var bedlist = $.unique(bedtypes.sort().reverse());
                var bathlist = $.unique(bathtypes.sort().reverse());

                // because we can get Deck 10, Deck 8, Deck 9... different type of sort
                var decklist = $.unique(
                    decktypes.sort(function (a, b) {
                        var pa = parseInt(a.replace(/[^0-9\.]/g, ''), 10);
                        var pb = parseInt(b.replace(/[^0-9\.]/g, ''), 10);
                        return pa - pb;
                    })
                );


            }

            window.loadedModules("BookingEngine/app-OceanCruises");
        }
    };
});
